<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <ToysList />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import ToysList from '@/components/Toys/ToysList'

export default {
  name: 'ToysIndexView',
  components: {
    Layout,
    ToysList
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Cadastros',
        to: { name: 'RegistersIndex' }
      },
      {
        text: 'Brinquedos',
        to: { name: 'ToysIndex' },
        active: true
      }
    ]
  }
}
</script>
